<div class="form-group container" id="create-new-virtual-session.component">
    <div class="row" style="margin-bottom: 50px;">
        <div class="col-md-12">
            <div
                class="alert alert-success"
                *ngIf="success"
                jhiTranslate="training-detail.virtual-session.messages.success"
            >
                <strong>Virtual session saved!</strong>
            </div>
            <h1>
                <i class="fa fa-bookmark-o fa-pre" aria-hidden="true"></i>
                {{
                    'training-detail.training.virtual-session.pageTitle'
                        | translate
                }}
            </h1>
            <form
                name="form"
                role="form"
                #virtualSessionForm="ngForm"
                novalidate
                show-validation
                class="form-horizontal"
            >
                <div class="form-group">
                    <label class="control-label col-sm-2" for="title">
                        {{
                            'training-detail.training.virtual-session.title'
                                | translate
                        }}
                    </label>
                    <div class="col-sm-4">
                        <input
                            type="text"
                            class="form-control"
                            id="title"
                            name="title"
                            placeholder="{{
                                'training-detail.training.virtual-session.form.title.placeholder'
                                    | translate
                            }}"
                            #titleInput="ngModel"
                            [(ngModel)]="virtualSession.title"
                            minlength="1"
                            maxlength="50"
                            required
                        />
                    </div>
                    <div class="control-error col-sm-4">
                        <div *ngIf="titleInput.dirty && titleInput.invalid">
                            <small
                                class="form-text text-danger"
                                *ngIf="titleInput.errors.required"
                            >
                                {{
                                    'training-detail.training.virtual-session.messages.validate.title.required'
                                        | translate
                                }}
                            </small>
                            <small
                                class="form-text text-danger"
                                *ngIf="titleInput.errors.minlength"
                            >
                                {{
                                    'training-detail.training.virtual-session.messages.validate.title.minlength'
                                        | translate
                                }}
                            </small>
                            <small
                                class="form-text text-danger"
                                *ngIf="titleInput.errors.maxlength"
                            >
                                {{
                                    'training-detail.training.virtual-session.messages.validate.title.maxlength'
                                        | translate
                                }}
                            </small>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="control-label col-sm-2" for="estimationDate">
                        {{
                            'training-detail.training.virtual-session.estimationDate'
                                | translate
                        }}
                    </label>
                    <div class="col-sm-4">
                        <input
                            type="text"
                            class="form-control"
                            id="estimationDate"
                            name="estimationDate"
                            placeholder="{{
                                'training-detail.training.virtual-session.form.estimation-date.placeholder'
                                    | translate
                            }}"
                            [(ngModel)]="virtualSession.estimationDate"
                            minlength="1"
                            maxlength="50"
                            #estimationDateInput="ngModel"
                            required
                        />
                    </div>
                    <div class="control-error col-sm-4">
                        <div
                            *ngIf="
                                estimationDateInput.dirty &&
                                estimationDateInput.invalid
                            "
                        >
                            <small
                                class="form-text text-danger"
                                *ngIf="estimationDateInput.errors.required"
                            >
                                {{
                                    'training-detail.training.virtual-session.messages.validate.estimation-date.required'
                                        | translate
                                }}
                            </small>
                            <small
                                class="form-text text-danger"
                                *ngIf="estimationDateInput.errors.minlength"
                            >
                                {{
                                    'training-detail.training.virtual-session.messages.validate.estimation-date.minlength'
                                        | translate
                                }}
                            </small>
                            <small
                                class="form-text text-danger"
                                *ngIf="estimationDateInput.errors.maxlength"
                            >
                                {{
                                    'training-detail.training.virtual-session.messages.validate.estimation-date.maxlength'
                                        | translate
                                }}
                            </small>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="control-label col-sm-2" for="message">
                        {{
                            'training-detail.training.virtual-session.message'
                                | translate
                        }}
                    </label>

                    <div class="col-sm-4">
                        <input
                            type="text"
                            class="form-control"
                            id="message"
                            name="message"
                            placeholder="{{
                                'training-detail.training.virtual-session.form.message.placeholder'
                                    | translate
                            }}"
                            [(ngModel)]="virtualSession.message"
                            minlength="1"
                            #messageInput="ngModel"
                            required
                        />
                    </div>
                    <div class="control-error col-sm-4">
                        <div *ngIf="messageInput.dirty && messageInput.invalid">
                            <small
                                class="form-text text-danger"
                                *ngIf="messageInput.errors.required"
                            >
                                {{
                                    'training-detail.training.virtual-session.messages.validate.message.required'
                                        | translate
                                }}
                            </small>
                            <small
                                class="form-text text-danger"
                                *ngIf="messageInput.errors.minlength"
                            >
                                {{
                                    'training-detail.training.virtual-session.messages.validate.message.minlength'
                                        | translate
                                }}
                            </small>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label
                        class="control-label col-sm-2"
                        for="archived"
                        jhiTranslate="training-detail.training.virtual-session.archived"
                    >
                        Archived
                    </label>
                    <div class="col-sm-4">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            id="archived"
                            name="archived"
                            [(ngModel)]="virtualSession.archived"
                        />
                    </div>
                </div>
                <div class="form-group form-validation">
                    <div class="col-sm-4 col-sm-offset-2">
                        <button
                            type="submit"
                            class="btn btn-primary"
                            [disabled]="virtualSessionForm.form.invalid"
                            (click)="save()"
                        >
                            {{
                                'training-detail.training.virtual-session.save'
                                    | translate
                            }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/session/staffing/create/create.component.html